import { usePresence } from '@common/hooks/usePresence';
import { Flex, Separator } from '@radix-ui/themes';
import { useMemo } from 'react';
import { UseSelectionResult } from '../hooks';

import { BulkActions } from '@common/components/Actions/BulkActions';
import { Action } from '@common/types/actions';
import styles from './SelectionRow.module.css';

interface TableBulkActionsProps<TData extends { id: string }> {
    selectionState: UseSelectionResult<TData>;
    actions: Action<TData>[];
}

export const TableBulkActions = <TData extends { id: string }>({
    selectionState,
    actions,
}: TableBulkActionsProps<TData>) => {
    const selectedItems = useMemo(() => {
        return Object.values(selectionState.selectedItems).filter(
            (value): value is TData =>
                typeof value === 'object' && value !== null,
        );
    }, [selectionState.selectedItems]);

    const { shouldRender, presenceProps } = usePresence(
        selectedItems.length > 0,
        500,
    );

    if (!shouldRender) return null;
    return (
        <Flex gap={'2'} className={styles.animatedContainer} {...presenceProps}>
            <Separator mr={'1'} orientation={'vertical'} size={'1'} />
            <BulkActions actions={actions} selectedItems={selectedItems} />
        </Flex>
    );
};
